/**
 * スタッフ出勤判定ユーティリティ
 *
 * priority の値で本日出勤/オフを判定する:
 *   - 1〜999: オフ
 *   - 1000〜1999: 本日出勤（= 1000 + オフ時の値）
 *
 * 他のコンポーネントからも利用可能な共通ユーティリティ。
 */

export const ON_DUTY_THRESHOLD = 1000;

/** 出勤中かどうかを判定 */
export const isOnDuty = (priority: number | null | undefined): boolean =>
  typeof priority === 'number' && priority >= ON_DUTY_THRESHOLD;

/** ベース優先度（オフ時の値 1〜999）を取得 */
export const basePriority = (priority: number): number =>
  ((priority % ON_DUTY_THRESHOLD) || 0);

/** 出勤状態にする（1000を加算） */
export const toOnDuty = (priority: number): number =>
  basePriority(priority) + ON_DUTY_THRESHOLD;

/** オフ状態にする（1000未満に正規化） */
export const toOffDuty = (priority: number): number =>
  basePriority(priority);
